import { render, staticRenderFns } from "./PollingTable.vue?vue&type=template&id=1bb94f23&scoped=true&"
import script from "./PollingTable.vue?vue&type=script&lang=js&"
export * from "./PollingTable.vue?vue&type=script&lang=js&"
import style0 from "./PollingTable.vue?vue&type=style&index=0&id=1bb94f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb94f23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
